import { mapApiDataToGuide } from '@/lib/cms-mappers';
import { guidesLocales } from '@/config/locales';

import type { FGuideTemplateProps } from '@/components/templates/FGuideTemplate.vue';

/**
 * Returns guide data fetched from CMS (Strapi), based on its slug
 * @param slug - Guide slug
 */
export async function useCmsGuide(
  slug: string
): UseCmsResponse<FGuideTemplateProps | null> {
  const { data, error, pending, refresh } = await useStrapi('guides', {
    localesSubset: guidesLocales,
    queryParams: {
      filters: { slug },
      populate: ['audience', 'topics', 'image', 'chapters', 'value_props'],
    },
  });

  const mappedData = computed(() => mapApiDataToGuide(data.value?.data));
  return { data: mappedData, error, pending, refresh };
}
